// asterisk icon rotate 360
document.addEventListener("DOMContentLoaded", function () {
  const asteriskIcons = document.querySelectorAll('.icon-rotate-360');
  if (asteriskIcons.length === 0) return; // Exit if no elements found
  asteriskIcons.forEach((el) => {
    gsap.fromTo(
      el,
      { rotate: 0 }, // initial state
      {
        rotate: 360,
        duration: 1.5,
        delay: 0.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 97%',
          //toggleActions: 'restart pause resume pause',
          toggleActions: 'play reverse play reverse',
          //markers: true,
        },
      }
    );
  });
});
